/**
 * Local seed data for the Profile feature — additive fields layered on top
 * of the auth user (bio/location/stats-for-display) plus Scribbles, which
 * have no home anywhere else in the app yet. Stands in for the eventual
 * API response; scribbles reference the same book ids as bookshelf's
 * SEED_BOOKS so a profile always reads as a coherent, connected shelf.
 */

const DAY = 24 * 60 * 60 * 1000;
const now = Date.now();

export const PROFILE_EXTRAS = {
  bio: "Books, coffee & stories that stay with me. Currently chasing every fantasy novel with a library hidden somewhere in it.",
  location: 'Mumbai, India',
  website: 'scribblereads.app/sakshi.reads',
  joinedAt: new Date('2026-01-14').getTime(),
  followers: 312,
  following: 148,
  // null = show the default ScribbleReads banner; otherwise a data: URL
  // (or, once a backend exists, a hosted image URL) persisted locally.
  bannerImage: null,
  favoriteOrder: ['book_circe', 'book_cerulean_sea', 'book_night_circus', 'book_hail_mary', 'book_piranesi'],
  privacy: {
    publicProfile: true,
    showReadingActivity: true,
    showEmail: false,
  },
};

export const SEED_SCRIBBLES = [
  {
    id: 'scribble_circe',
    bookId: 'book_circe',
    bookTitle: 'Circe',
    bookAuthor: 'Madeline Miller',
    tone: 'yellow',
    rating: 5,
    quote: 'I loved him as a human loves — as a doomed thing loves.',
    body: "Miller writes gods the way the rest of us actually feel — petty, aching, capable of tenderness they didn't ask for. I read the last forty pages on a train platform and missed my stop.",
    createdAt: now - 2 * DAY,
    likes: 24,
  },
  {
    id: 'scribble_cerulean_sea',
    bookId: 'book_cerulean_sea',
    bookTitle: 'The House in the Cerulean Sea',
    bookAuthor: 'TJ Klune',
    tone: 'sage',
    rating: 5,
    quote: "Love should never be a weapon, though it seems it always is.",
    body: 'A book that is gentle on purpose, which is its own kind of brave. Kept it by the bed for a week after finishing just to look at the cover.',
    createdAt: now - 9 * DAY,
    likes: 41,
  },
  {
    id: 'scribble_legends_lattes',
    bookId: 'book_legends_lattes',
    bookTitle: 'Legends & Lattes',
    bookAuthor: 'Travis Baldree',
    tone: 'coral',
    rating: 4,
    quote: 'A reminder that sometimes the story you want is a warm room and a good cup of coffee.',
    body: 'Cozy fantasy done right — low stakes, high comfort. Perfect for the week I needed to not be worried about anything, including the characters.',
    createdAt: now - 18 * DAY,
    likes: 16,
  },
  {
    id: 'scribble_study_drowning',
    bookId: 'book_study_drowning',
    bookTitle: 'A Study in Drowning',
    bookAuthor: 'Ava Reid',
    tone: 'blue',
    rating: 4,
    quote: 'Some stories are lies that tell the truth anyway.',
    body: 'Atmospheric to the point of being uncomfortable, in the best way. The academic-rivals-to-something-else arc earns every slow page.',
    createdAt: now - 30 * DAY,
    likes: 12,
  },
];
